import { method } from "lodash"
import { api } from "shared/redux/api"
import { objectToQueryString } from "shared/utils/common"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployeeInformation: build.mutation({
      query: (arg) => {
        const { email } = arg
        return {
          url: "/private/fpt/v1/information",
          method: "POST",
          body: {
            MaNhanVien: "",
            TuNgayVaoLam: "",
            DenNgayVaoLam: "",
            MaTinhTrangNhanVien: "",
            MaLoaiNhanVien: "",
            MaCongTy: "",
            MaDonViCap1: "",
            MaDonViCap2: "",
            MaDonViCap3: "",
            MaDonViCap4: "",
            MaHLevel1: "",
            MaHLevel2: "",
            MaHLevel3: "",
            MaHLevel4: "",
            MaNoiLamViec: "",
            TuNgayThoiViec: "",
            DenNgayThoiViec: "",
            EmailCongTy: email,
          },
        }
      },
    }),
    getLabourInformation: build.mutation({
      query: (arg) => {
        const { empCode } = arg
        return {
          url: "/private/fpt/v1/contract",
          method: "POST",
          body: {
            EmpCode: empCode,
            EffectiveDate: "",
            ToDate: "",
            HopDongMoiNhat: "0",
          },
        }
      },
    }),
    getLeaveInformation: build.mutation({
      query: (arg) => {
        const { empCode, start, end } = arg
        return {
          url: "/private/fpt/v1/dayOff",
          method: "POST",
          body: {
            FromDate: start,
            ToDate: end,
            EmpCode: empCode,
          },
        }
      },
    }),
    getRemainingLeave: build.mutation({
      query(arg) {
        const { type, empCode } = arg
        return {
          url: "/private/fpt/v1/leaveDay",
          method: "POST",
          body: {
            EmpCode: empCode,
            Type: type,
          },
        }
      },
    }),
    getListLeave: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/leave/v2?${objectToQueryString(arg)}`,
        }
      },
    }),
    getLeaveSummary: build.query({
      query: () => {
        return {
          url: "/private/leave/v1/summary",
        }
      },
    }),
    getListDetail: build.query({
      query: (id) => {
        return {
          url: "/private/leave/v1/" + id,
        }
      },
    }),
    getLeaveAwareDetail: build.query({
      query: (id) => {
        return {
          url: `/private/leave/v1/${id}/aware`,
        }
      },
    }),
    actionLeave: build.mutation({
      query: (arg) => {
        const { type } = arg
        return {
          url: "/private/leave/v1/2/" + type,
          method: "POST",
          body: arg,
        }
      },
    }),
    approveLeaveRequestAdmin: build.mutation({
      query: (id) => {
        return {
          url: `/private/leave/v1/${id}/approve`,
          method: "POST",
        }
      },
    }),
    rejectLeaveRequestAdmin: build.mutation({
      query: (arg) => {
        const { id, rejectionReason } = arg
        return {
          url: `/private/leave/v1/${id}/reject`,
          method: "POST",
          body: { rejectionReason },
        }
      },
    }),
    submitLeaveForm: build.mutation({
      query: (arg) => {
        const { type } = arg
        return {
          url: "/private/leave/v1",
          method: "POST",
          body: arg,
        }
      },
    }),
    getPaySlipList: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/fpt/v1/paySlip`,
          method: "POST",
          body: arg,
        }
      },
    }),
    uploadFile: build.mutation({
      query: (arg) => {
        return {
          url: "/private/leave/v1/file/upload",
          method: "POST",
          body: arg,
        }
      },
    }),
    updateLeaveForm: build.mutation({
      query: (arg) => {
        const { id, ...body } = arg
        return {
          url: `/private/leave/v1/${id}/draft`,
          method: "POST",
          body,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetEmployeeInformationMutation,
  useGetLabourInformationMutation,
  useGetLeaveInformationMutation,
  useGetRemainingLeaveMutation,
  useLazyGetListLeaveQuery,
  useLazyGetLeaveSummaryQuery,
  useLazyGetListDetailQuery,
  useLazyGetLeaveAwareDetailQuery,
  useActionLeaveMutation,
  useApproveLeaveRequestAdminMutation,
  useRejectLeaveRequestAdminMutation,
  useSubmitLeaveFormMutation,
  useLazyGetPaySlipListQuery,
  useUploadFileMutation,
  useUpdateLeaveFormMutation,
} = injectedRtkApi
